var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6197 1.38281C12.3999 1.38281 11 4.31595 11 4.31595C10.7134 3.77265 10.3434 3.27602 9.90341 2.84938C8.97014 1.90944 7.70356 1.38281 6.38031 1.38281C3.16053 1.38281 0.497375 4.0093 1.08067 7.9357C1.6673 11.8621 5.59703 15.1019 11 18.6217C13.6998 16.8651 16.033 15.1719 17.7662 13.432C19.4961 11.6855 20.626 9.89891 20.9193 7.93237C21.5026 4.00597 18.8395 1.38281 15.6197 1.38281Z",
    stroke: "#315146",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeart;